import { render, staticRenderFns } from "./addToCartSuccessModal.vue?vue&type=template&id=1b3aafb4&scoped=true&"
import script from "./addToCartSuccessModal.vue?vue&type=script&lang=ts&"
export * from "./addToCartSuccessModal.vue?vue&type=script&lang=ts&"
import style0 from "./addToCartSuccessModal.vue?vue&type=style&index=0&id=1b3aafb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3aafb4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
